<template>
  <div class="popup__layer active">
    <div class="popup__edit">
      <div class="popup__close" @click="close(true)">
        <span class="glicon-close-large"></span>
      </div>
      <div class="popup__feedback">
        <div class="popup__feedback--image failed">
          <span class="glicon-alert-thin"></span>
        </div>
        <div class="popup__feedback--subtitle">
          {{ $t('account.forms.deactivateMailAnimationTitle') }}
        </div>
        <div class="popup__feedback--text">
          {{ $t('account.forms.deactivateMailAnimationText') }}
        </div>
        <div class="popup__feedback--text failed">
          {{ $t('account.forms.deactivateMailAnimationWarning') }}
        </div>
      </div>
      <div class="popup__buttons">
        <gl-button
          id="config.deactivate-mail"
          color-secondary
          :type="'button'"
          :text="$t('account.forms.deactivateMailAnimation')"
          @onClick.prevent="close(false)"
        ></gl-button>
        <gl-button
          id="config.activate-mail"
          color-primary
          :type="'button'"
          :text="$t('account.forms.activateMailAnimation')"
          @onClick.prevent="close(true)"
        ></gl-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupClientConfig',
  methods: {
    close(accept) {
      this.$emit('close', accept);
    }
  }
};
</script>
